"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateGuid = void 0;
exports.generateGuid = function () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // tslint:disable: no-bitwise
        var r = (Math.random() * 16) | 0, v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};
//# sourceMappingURL=generateGuid.js.map